// src/pages/admin/transaction/TransactionDetailsPage.js
import React from "react";
import { useParams } from "react-router-dom";
import TransactionDetailsView from "../../components/admin/transactions-too/TransactionDetailsView";

export default function TransactionDetailsPage() {
  const { id } = useParams(); // correspond à :id dans tes routes

  return (
    <TransactionDetailsView
      apiUrl={process.env.REACT_APP_API_URL}
      transactionId={id} // passé comme prop
    />
  );
}
